<script>
   /*************************************************************************
   * BoxplotSeries                                                          *
   * --------------------                                                   *
   * Svelte component to show boxes and whiskers for data matrix columns    *
   **************************************************************************/

   //! TODO: implement outliers detection and visualisation

   import { Vector, ismatrix } from 'mdatools/arrays';
   import { quantile, min, max } from 'mdatools/stat';
   import { Colors, Segments, Rectangles } from 'svelte-plots-basic/2d';

   /*****************************************/
   /* Input parameters                      */
   /*****************************************/

   export let values;                              // Matrix with values
   export let borderColor = Colors.PRIMARY;        // color of box borders and whiskers
   export let faceColor = Colors.PRIMARY_LIGHT;    // color of box face

   // check the inputs
   $: if (!values || !ismatrix(values) || values.nrows < 2 || values.ncols < 1) {
      throw new Error('BoxplotSeries: values must be a matrix with at least 2 rows.');
   }

   // compute coordinatesfor the box and whiskers
   let left, right, top, bottom, height, width, mn, mx, mid, med;
   $: {
      const n = values.ncols;

      left = Vector.zeros(n);
      right = Vector.zeros(n);
      width = Vector.fill(0.8, n);
      top = Vector.zeros(n);
      bottom = Vector.zeros(n);
      height = Vector.zeros(n);
      mn = Vector.zeros(n);
      mx = Vector.zeros(n);
      mid = Vector.zeros(n);
      med = Vector.zeros(n);

      for (let i = 1; i <= values.ncols; i++) {
         const v = values.getcolref(i);
         left.v[i - 1] = i - 0.4;
         mid.v[i - 1] = i;
         right.v[i - 1] = i + 0.4;

         const q = quantile(v, [0.25, 0.50, 0.75]);
         top.v[i - 1] = q.v[2];
         bottom.v[i - 1] = q.v[0];
         height.v[i - 1] = q.v[2] - q.v[0];
         med.v[i - 1] = q.v[1];
         mn.v[i - 1] = min(v);
         mx.v[i - 1] = max(v);
      }
   }
</script>

{#if values }
   <Rectangles {left} {top} {width} {height} {borderColor} {faceColor} />
   <Segments xStart={mid} yStart={top} xEnd={mid} yEnd={mx} lineColor={borderColor}/>
   <Segments xStart={mid} yStart={bottom} xEnd={mid} yEnd={mn} lineColor={borderColor}/>
   <Segments xStart={left} yStart={med} xEnd={right} yEnd={med} lineColor={borderColor}/>
{/if}


